"use client";

import Navbar from "@/components/ui/Navbar";
import Footer from "@/components/sections/Footer";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";
import { ArrowUpRight, Smartphone, Globe, Code, Zap, Shield, Layout, Bell, Fingerprint, Play, SkipBack, SkipForward, Heart, Menu, Cpu, PlayCircle, MapPin, Thermometer, Sun, Lock, Wifi, Power } from "lucide-react";
import OurWork from "@/components/sections/app-development/OurWork";

import ProjectShowcase from "@/components/sections/app-development/ProjectShowcase";
import AppElements from "@/components/sections/app-development/AppElements";
import DetailedProcess from "@/components/sections/app-development/DetailedProcess";
import DarkModeShowcase from "@/components/sections/app-development/DarkModeShowcase";

import AppDownloadCTA from "@/components/sections/app-development/AppDownloadCTA";
import FutureOfMusic from "@/components/sections/app-development/FutureOfMusic";

const ecosystems = [
    {
        title: "iOS",
        subtitle: "Apple Ecosystem",
        icon: <Smartphone className="w-6 h-6 text-white" />,
        desc: "Native Swift applications that feel right at home on every iPhone and iPad.",
        color: "bg-white/5"
    },
    {
        title: "Android",
        subtitle: "Google Play",
        icon: <Code className="w-6 h-6 text-white" />,
        desc: "Kotlin-first development ensuring performance across the fragmented device landscape.",
        color: "bg-white/5"
    },
    {
        title: "Hybrid",
        subtitle: "Universal",
        icon: <Globe className="w-6 h-6 text-white" />,
        desc: "React Native & Flutter solutions for rapid deployment on both platforms.",
        color: "bg-white/5"
    },
];

const techStack = ["SwiftUI", "Kotlin", "React Native", "Flutter", "Firebase", "GraphQL"];


export default function AppDevelopmentPage() {
    return (
        <main className="min-h-screen bg-[#1C1C1C] text-white selection:bg-white selection:text-black overflow-hidden">
            <Navbar />

            {/* Future of Music Section - New Addition */}
            <FutureOfMusic />

            {/* Project Showcase Section - New Addition */}
            <ProjectShowcase />

            {/* App Elements Section - New Addition */}
            <AppElements />





            {/* Detailed Process Section - New Addition */}
            <DetailedProcess />



            {/* App Download CTA Section - New Addition */}
            <AppDownloadCTA />


            {/* Tech Stack Marquee */}
            <section className="py-16 md:py-24 bg-[#050505] border-t border-white/5 overflow-hidden">
                <div className="container mx-auto mb-8 md:mb-12 px-6 md:px-20 lg:px-40">
                    <p className="text-xs sm:text-sm uppercase tracking-widest text-gray-500">The Toolbelt</p>
                </div>
                <div className="relative flex overflow-x-hidden">
                    <div className="animate-marquee whitespace-nowrap flex gap-10 md:gap-16 items-center">
                        {/* Double the list for seamless loop */}
                        {[...techStack, ...techStack, ...techStack].map((tech, index) => (
                            <span key={index} className="text-4xl md:text-6xl font-bold tracking-tighter text-white/20 hover:text-white/80 transition-colors cursor-default">
                                {tech}
                            </span>
                        ))}
                    </div>
                </div>
            </section>


            <Footer />
        </main >
    );
}
